import { Component } from '@angular/core';
import { LoadingIndicatorPanelComponent } from '../../../loading-indicator/loading-indicator-panel.component';
import { DetailedLoadingIndicatorComponent } from '../../../detailed-loading-indicator/detailed-loading-indicator.component';

@Component({
  selector: 'td-wb-table-loading',
  templateUrl: 'table-loading.component.html',
  styleUrls: ['table-loading.component.scss'],
  imports: [LoadingIndicatorPanelComponent, DetailedLoadingIndicatorComponent]
})
export class TableLoadingComponent {
}
